module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Olsberg_AG-5b930dd33aa069dadceeb936b431be4d.svg";